<script setup lang="ts">
import { useCompanyStore } from '@Stores/company.store';
import { useLocationStore } from '@Stores/location.store';
import { GuidedShowcaseLayout, ErrorScreenLayout, SupportEmailLink } from '@Shared';
import useCompanyImageBaseUrl from '@Src/use/useCompanyImageBaseUrl';
import useCompanyName from '@Use/useCompanyName';
import CancelledGraphic from '@Assets/images/cancelled.svg';
import ShowcaseImage from '@Components/shared/ShowcaseImage.vue';

const companyImageBaseUrl = useCompanyImageBaseUrl();
const companyStore = useCompanyStore();
const locationStore = useLocationStore();
const { companyName } = useCompanyName('your closing team');
</script>

<template>
    <guided-showcase-layout
        :company="companyStore.company"
        :brand="companyStore.brand"
        :location="locationStore.location"
        :company-image-base-url="companyImageBaseUrl"
        :steps="['expired']"
        :current-step="0">

        <div class="request-expired-content">
            <error-screen-layout
                :image="CancelledGraphic"
                image-alt="Request Expired"
                title="Request expired"
                image-width="6.25rem"
                image-height="7.25rem">
                <p>
                    This request can't be completed because it is no longer active.
                </p>
                <p>
                    If you believe you need to complete it, or that this is an error, contact
                    {{ companyName }} for help.
                </p>
                <p>
                    You can also contact <support-email-link />.
                </p>
            </error-screen-layout>
        </div>

        <template #branded>
            <showcase-image />
        </template>
    </guided-showcase-layout>
</template>

<style lang="scss" scoped>
@use "certifid-v2-client-hub-styles" as *;
</style>
